import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import MuiDialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { useStyles } from './styles';

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide ref={ref} {...props} />;
});

const Dialog = ({ open, handleClose, direction, title, content, actions, ...rest }) => {
	const classes = useStyles({ title });
	const id = title + '-dialog';

	return (
		<MuiDialog
			open={open}
			TransitionComponent={Transition}
			onClose={handleClose || rest.onClose}
			keepMounted={rest.keepMounted || true}
			aria-labelledby={id}
			{...rest}
			classes={{ paper: classes.dialogPaper }}>
			{(title || handleClose) && (
				<DialogTitle id={id} className={classes.title}>
					<Grid container direction="row" justify={title ? 'space-between' : 'flex-end'} alignItems="center">
						{title && (
							<Grid item>
								<Typography variant="h6">{title}</Typography>
							</Grid>
						)}

						{handleClose && (
							<Grid item>
								<IconButton aria-label="Close" onClick={handleClose}>
									<CloseIcon />
								</IconButton>
							</Grid>
						)}
					</Grid>
				</DialogTitle>
			)}

			<DialogContent className={classes.content}>{content}</DialogContent>

			{actions && <DialogActions className={classes.actions}>{actions}</DialogActions>}
		</MuiDialog>
	);
};

Dialog.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func,
	direction: PropTypes.string,
	title: PropTypes.string,
	content: PropTypes.node.isRequired,
	actions: PropTypes.node
};

export default Dialog;
